<header class="site-header" id="top">
  <div class="site-header__inner">
    <a href="https://www.thurrock.gov.uk/" class="site-header__logo">
      <img src="assets/images/thurrock-logo.png" alt="" class="site-header__logo-image" width="30" height="30" />
      <span class="site-header__site-name">thurrock.gov.uk</span>
    </a>
  </div>
</header>
